import { ICoordinates } from 'react-give-me-map';

export function fromLatLngToCoordinates(locations: ICoordinates[]) {
    return locations.map((location) => [location.lng, location.lat]);
}

export function coordsToArrays(coords: ICoordinates[]) {
    return coords.map((coord) => [coord.lng, coord.lat]) as [
        [number, number],
        [number, number],
        [number, number],
        [number, number]
    ];
}

export function removeTypeName<T>(data: T): T {
    if (Array.isArray(data)) {
        // If the input is an array, recursively process each item
        return data.map((item) => removeTypeName(item)) as T;
    } else if (typeof data === 'object' && data !== null) {
        // If the input is an object, recursively process its properties
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { __typename, ...rest } = data as Record<string, unknown>;
        return Object.keys(rest).reduce((acc, key) => {
            acc[key] = removeTypeName(rest[key]);
            return acc;
        }, {} as Record<string, unknown>) as T;
    }
    // If the input is a primitive value, return it as is
    return data;
}

export function getBoundingBox(coordinates: ICoordinates[]) {
    if (!coordinates || coordinates.length === 0) {
        console.error('No coordinates provided');
        return;
    }

    // Calculate the bounding box
    const bounds = coordinates.reduce(
        (acc, { lat, lng }) => {
            return {
                minLat: Math.min(acc.minLat, lat),
                maxLat: Math.max(acc.maxLat, lat),
                minLng: Math.min(acc.minLng, lng),
                maxLng: Math.max(acc.maxLng, lng)
            };
        },
        {
            minLat: Infinity,
            maxLat: -Infinity,
            minLng: Infinity,
            maxLng: -Infinity
        }
    );

    return bounds;
}
